export default "__VITE_ASSET__BEBquAZD__"